import React,{ createContext, useContext } from "react";
import useInitialState from "../hooks/useInitialState";

export const CambiarContrasenaContext = createContext();


export const CambiarContrasenaProvider = ({children}) => {
    const initialState = useInitialState()
    return <CambiarContrasenaContext.Provider value={initialState}>
        {children}
    </CambiarContrasenaContext.Provider>
}

export const useCambiarContrasenaContext = () => {
    
    const context = useContext(CambiarContrasenaContext)
    if(context === undefined){
        throw new Error('CambiarContrasenaContext must be used within a CambiarContrasenaProvider')
    }
    return context
}